<template>
  <div class="bg-gray">
    <div class="form-content" v-loading="loading">
      <el-form :model="row"
               ref="ruleForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <div class="order-success">
              <div class="icon"></div>
              <div class="title">报名成功</div>
              <div class="desc">
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <div class="order-success">
                <img :src="row.erweiimg[0].url" v-if="row.erweiimg.length>0"/>
                <p v-if="row.erweiimg.length>0">扫码加工作人员好友，进入培训微信群</p>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>场次信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位：">
              <div>{{ row.danwei }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="场次：">
              <div>{{ row.station_name }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时间：">
              <div>{{ row.station.startdate + '至' + row.station.enddate }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>个人信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="省市区：">
              <div>{{ row.province + '  ' + row.city + ' ' + row.county + ' ' + row.address }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名：">
              <div>{{ row.member.name }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号：">
              <div>{{ row.member.num }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
              <div>{{ row.member.phone }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="cert-li" v-if="row.cert_url && row.cert_url.url">
          <el-divider>结业证书</el-divider>
          <img :src="row.cert_url.url" alt="">
          <div class="cert-button">
            <el-button @click="appDownload(row.cert_url.filename,row.cert_url.url)"
                        style="margin: 10px auto; text-align: center " type="default" round>点击下载
            </el-button>
          </div>
        </div>


        <el-divider>资料信息</el-divider>
        <el-row>
          <el-col :span="12" v-for="(goods,index) in row.goods_list" :key="inedx">
            <el-form-item :label="goods.item_title">
              <div>{{ goods.count+''+goods.unit +' ' }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button v-if="row.next_gjsb" round v-rblink="{name:'SongpeiApplyFormStep3' ,query:{ id:row.id }}">资质申报
            </el-button>
            <el-button round @click="toStep2">资料订购
            </el-button>

            <el-button v-if="row.station.can_exame==1" round v-rblink="{name:'SongpeiExame' ,query:{ id:row.id }}">在线考试
            </el-button>

            <el-button type="primary" round v-rblink="{name:'SongpeiApplyList'}">我的报名记录
            </el-button>
          </el-col>
        </el-row>

      </el-form>
    </div>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.order-success .desc {
  padding: 10px;
  text-align: left;
}

.order-success .desc p {
  line-height: 26px;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.order-success img {
  width: 40%;
  /*height: 120px;*/
  margin: 10px auto;
}

.order-success p {
  font-size: 16px;
  color: #999;
}

.sai-shuo-li {
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px;
  padding: 10px;
}

.sai-shuo-li img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}

.sai-shuo-li .c {
  width: calc(100% - 80px);
  border-right: 1px solid #00000008;
}

.sai-shuo-li .c .title {
  font-size: 14px;
  color: #000;
}

.sai-shuo-li .c .desc {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li .fr {
  width: 70px;
  float: right;
}

.sai-shuo-li .btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 6px;
  color: #fff;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


import jquery from 'jquery';

jquery.fn.longPress = function (fn) {
  let timeout = 0;
  const $this = this;
  console.log('jquery.fn.longPress')
  for (let i = 0; i < $this.length; i++) {
    $this[i].addEventListener('touchstart', () => {
      timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
    }, false);
    $this[i].addEventListener('touchend', () => {
      clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
    }, false);
  }
};

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      ltShow: false,
      ltImgSrc: '',
      ltImgName: '',
      ltActions: [{name: '保存图片'}],
      validator,
      loading: true,
      saveLoading: false,
      showFamliyPicker: false,
      showSubjectPicker: false,
      showJiaolianPicker: false,
      showRoomTypePicker: false,
      showMemberPicker: false,
      formData: {
        id: 0
      },
      isApp: window.isApp(),
      row: {
        member: {},
        erweiimg: [],
        station: {},
        goods_list: []
      }
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    document.title = "申请成功"
    that.formData.id = this.$route.query.id;
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    appDownload(name, url) {
      let that = this;
      console.log('downloadPic', name, url);
      // return
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name + '.jpg',
          url: url,
        }
      });
    },
    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          let name = that.ltImgSrc.split('?')[0].split('/').pop();
          console.log(that.ltImgSrc, name);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': name,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    fetch() {
      let that = this;
      that.$api.post('/api/songpei/successdetail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;
        that.loading = false
      }, (res) => {
        that.$message.warning(res.msg);
        that.loading = false
      })
    },

    toStep2() {
      rbLink({name: 'SongpeiApplyFormStep2', query: {id: this.row.id}})
    }

  }
}
</script>



// WEBPACK FOOTER //
// SongpeiApplyFormSuccess.vue?a278a424